import { Box, useMediaQuery, useTheme } from "@mui/material";
import TourDeviationReportDesktop from "../components/desktop/tour-deviation-report/TourDeviationReportDesktop";
import TourDeviationReportMobile from "../components/mobile/tour-deviation-report-mob/TourDeviationReportMobile";

const TourDeviationReport = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <>
      <Box padding={2}>
        {isMobile ? (
          <TourDeviationReportMobile />
        ) : (
          <TourDeviationReportDesktop />
        )}
      </Box>
    </>
  );
};

export default TourDeviationReport;
